export default __webpack_public_path__ + "media/faq/lock-c66a1cfe.png";